import React, { Component } from "react";
import Lib from "mon-entreprise";

import Input from "./component/input";

export class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ca: "",
      wy: "",
      net: "",
      supernet: "",
      period: "year"
    }

    this.timeout = 0;
    this.decimals = 0;
    this.defaultThrottle = 300; //In ms for debounce function

    this.variable = {
      dirigeant: "auto-entrepreneur",
      "auto-entrepreneur": "oui",
      "entreprise . catégorie d'activité": "libérale",
      "entreprise . catégorie d'activité . libérale règlementée": "non",
      "entreprise . date de création": "01/01/2020",
      "entreprise . ACRE": "non",
      "auto-entrepreneur . impôt . versement libératoire": "non",
      "impôt . méthode de calcul": "barème standard",
      "situation personnelle . domiciliation fiscale à l'étranger": "non"
    };
  }

  onChangeCa = e => {
    const val = Number(e.target.value.replace(/\s/g, "")).toFixed(this.decimals);
    this.setState({ca: val});
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const wy = (val * 0.94).toFixed(this.decimals);
      const net = parseFloat(
        Lib.evaluate("dirigeant . auto-entrepreneur . net de cotisations", {
          "entreprise . chiffre d'affaires": wy,
          ...this.variable
        },{},["€/an"])
      ).toFixed(this.decimals);
      const supernet = parseFloat(
        Lib.evaluate("dirigeant . auto-entrepreneur . net après impôt", {
          "entreprise . chiffre d'affaires": val,
          ...this.variable
        },{},["€/an"])
      ).toFixed(this.decimals);
      this.setState({
        wy,
        net,
        supernet
      })
    }, this.defaultThrottle);
  };

  onChangeWy = e => {
    const val = Number(e.target.value.replace(/\s/g, "")).toFixed(this.decimals);
    this.setState({wy: val});
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const ca = (val / 0.94).toFixed(this.decimals);
      const net = parseFloat(
        Lib.evaluate("dirigeant . auto-entrepreneur . net de cotisations", {
          "entreprise . chiffre d'affaires": val,
          ...this.variable
        },{},["€/an"])
      ).toFixed(this.decimals);
      const supernet = parseFloat(
        Lib.evaluate("dirigeant . auto-entrepreneur . net après impôt", {
          "entreprise . chiffre d'affaires": val,
          ...this.variable
        },{},["€/an"])
      ).toFixed(this.decimals);
      this.setState({
        ca,
        net,
        supernet
      })
    }, this.defaultThrottle);
  };

  onChangeNet = e => {
    const val = Number(e.target.value.replace(/\s/g, "")).toFixed(this.decimals);
    this.setState({net: val});
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const wy = parseFloat(
        Lib.evaluate("entreprise . chiffre d'affaires", {
          "dirigeant . auto-entrepreneur . net de cotisations": val,
          ...this.variable
        },{},["€/an"])
      ).toFixed(this.decimals);
      const ca = (wy / 0.94).toFixed(this.decimals);
      const supernet = parseFloat(
        Lib.evaluate("dirigeant . auto-entrepreneur . net après impôt", {
          "dirigeant . auto-entrepreneur . net de cotisations": val,
          ...this.variable
        },{},["€/an"])
      ).toFixed(this.decimals);
      this.setState({
        wy,
        ca,
        supernet
      })
    }, this.defaultThrottle);
  };

  onChangePeriod = () => {
    const {period, ca, wy, net, supernet} = this.state;
    if (period === "year") {
      this.setState({
        period: "month",
        ca: (Number(ca.replace(/\s/g, "")) / 12).toFixed(this.decimals),
        wy: (Number(wy.replace(/\s/g, "")) / 12).toFixed(this.decimals),
        net: Number((net.replace(/\s/g, "")) / 12).toFixed(this.decimals),
        supernet: (Number(supernet.replace(/\s/g, "")) / 12).toFixed(this.decimals)
      })
    } else {
      this.setState({
        period: "year",
        ca: (Number(ca.replace(/\s/g, "")) * 12).toFixed(this.decimals),
        wy: (Number(wy.replace(/\s/g, "")) * 12).toFixed(this.decimals),
        net: Number((net.replace(/\s/g, "")) * 12).toFixed(this.decimals),
        supernet: (Number(supernet.replace(/\s/g, "")) * 12).toFixed(this.decimals)
      })
    }
  };

  formatNumber = (s) => {
    const formated = Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(s)
    return formated.substring(0, formated.length - 5)
  }

  onChangeSupernet = e => {
    const val = Number(e.target.value.replace(/\s/g, "")).toFixed(this.decimals);
    this.setState({supernet: val});
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const wy = parseFloat(
        Lib.evaluate("entreprise . chiffre d'affaires", {
          "dirigeant . auto-entrepreneur . net après impôt": val,
          ...this.variable
        },{},["€/an"])
      ).toFixed(this.decimals);
      const ca = (wy / 0.94).toFixed(this.decimals);
      const net = parseFloat(
        Lib.evaluate("dirigeant . auto-entrepreneur . net de cotisations", {
          "dirigeant . auto-entrepreneur . net après impôt": val,
          ...this.variable
        },{},["€/an"])
      ).toFixed(this.decimals);
      this.setState({
        wy,
        ca,
        net
      })
    }, this.defaultThrottle);
  }

  render() {
    const {period, ca, wy, net, supernet} = this.state;
    return (
      <div className="App">
        <label>
          <input
            type="radio"
            value="month"
            checked={period === "month"}
            onChange={() => this.onChangePeriod()}
          />
          Par mois
        </label>
        <label>
          <input
            type="radio"
            value="year"
            checked={period === "year"}
            onChange={() => this.onChangePeriod()}
          />
          Par an
        </label>
        <Input
          label="Cout total dépensé par l'entreprise"
          id="ca"
          value={this.formatNumber(ca)}
          placeholder="ex: 1000€"
          onChange={e => this.onChangeCa(e)}
        />
        <Input
          label="Revenu brut"
          id="wy"
          value={this.formatNumber(wy)}
          placeholder="ex: 1000€"
          onChange={e => this.onChangeWy(e)}
        />
        <Input
          label="Revenu net de cotisations avant impôt"
          id="net"
          value={this.formatNumber(net)}
          placeholder="ex: 1000€"
          onChange={e => this.onChangeNet(e)}
        />
        <Input
          label="Revenu net de cotisations après impôt"
          id="supernet"
          value={this.formatNumber(supernet)}
          placeholder="ex: 1000€"
          onChange={e => this.onChangeSupernet(e)}
        />
      </div>
    );
  }
};

export default App;
